module.exports = __webpack_public_path__ + "img/R-6.c34e38e8.png";